import { observer } from 'mobx-react';
import * as React from 'react';
import { inject } from '../../../utils/decorators';
import { AuftragStore } from '../../../stores/AuftragStore';
import Callout from '../../site/Callout';
import { BpsReferenzkraftKalibrierungStore } from '../../../stores/BpsReferenzkraftKalibrierungStore';
import { Panel } from 'react-bootstrap';

/**
 * Komponente zur Anzeige der für die Kalibrierung relevanten Daten zum gewählten Kraftmessgerät
 */
@observer
export default class BpsReferenzkraftKMGInfo extends React.Component<{}, {}> {

  @inject(AuftragStore) auftragStore: AuftragStore;
  @inject(BpsReferenzkraftKalibrierungStore) kalibrierungStore: BpsReferenzkraftKalibrierungStore;

  meta(bezeichnung: string) {
    const kmg = this.kalibrierungStore.kraftMessGeraet();
    if (kmg && kmg.meta) {
      let metaDatum = kmg.meta.find(meta => meta.bezeichnung === bezeichnung);
      return metaDatum && metaDatum.inhalt;
    }
    return undefined;
  }

  render() {
    const kmg = this.kalibrierungStore.kraftMessGeraet();
    if (kmg) {
      return (
        <Panel header={kmg.name} collapsible={true} defaultExpanded={false}>
          <b>Kraftbereich:</b> {this.meta('messbereich')} N<br/>
          <b>Max. Messunsicherheit:</b> {this.meta('messunsicherheit_max')}<br/>
          <b>Skalenteilung:</b> {this.meta('auflösung')}<br/>
          <b>Wiederholpräzision:</b> {this.meta('wiederholpräzision')}<br/>
        </Panel>
      );
    } else {
      return (
        <Callout bsStyle="danger">
          <p>Es wurde noch kein Kraftmessgerät ausgewählt!</p>
        </Callout>
      );
    }
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/BpsReferenzkraftKMGInfo.tsx